import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const ListingValuationType1 = union([
    literal("desktop"),
    literal("video"),
    literal("in_person"),
    literal("undetermined"),
]);
